import React, { useState, useEffect, useRef } from 'react'; 
import { 
  FaSearch, 
  FaSignOutAlt, 
  FaBars, 
  FaExclamationTriangle, 
  FaTimes,
  FaCrown,
  FaBell,
  FaUserCircle,
  FaUser,
  FaChevronDown,
  
  
 
} from 'react-icons/fa';
import * as XLSX from 'xlsx';
import axios from 'axios';
import logo from '../asset/logo512.png';
import CONFIG from '../config';
const TopNavbar = ({ 
  sidebarOpen, 
  setSidebarOpen, 
  searchQuery, 
  setSearchQuery,
  handleLogout,
  onCompanySelect,
  fullscreenMode,
  onHomeClick,
  activeSection,
  onDataClick,
  showBackArrow,
  onBackClick,
  userRole = 'user',
  // New props for upload/download
  onExcelUpload,
  onExcelDownload,
  activeStatement = 'Income Statement',
  currentCompany = null,
  // New prop for financial data
  financialData = null
}) => {
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [filteredCompanies, setFilteredCompanies] = useState([]);
  const [showCompanyList, setShowCompanyList] = useState(false);
  const [notifications, setNotifications] = useState([
    { id: 1, text: 'System update scheduled', time: '10 min ago', read: false },
    { id: 2, text: 'New user registered', time: '1 hour ago', read: false },
    { id: 3, text: 'Database backup completed', time: '2 hours ago', read: true }
  ]);
  const [showNotifications, setShowNotifications] = useState(false);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const searchRef = useRef(null);
  const notificationsRef = useRef(null);
  const profileRef = useRef(null);
  const fileInputRef = useRef(null);

  // Get user info from localStorage
  const [currentUser, setCurrentUser] = useState(() => {
    try {
      const user = JSON.parse(localStorage.getItem('currentUser') || '{}');
      return user;
    } catch (error) {
      return {};
    }
  });



  // Get auth headers
  const getAuthHeaders = () => {
    const token = localStorage.getItem('access_token');
    return {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    };
  };

  // Determine current section based on role
  const currentSection = activeSection || (userRole === 'superadmin' ? 'dashboard' : 'home');

  // Search companies from backend API
  useEffect(() => {
    // In the searchCompanies function in TopNavbar.jsx
const searchCompanies = async () => {
  if (!searchQuery || searchQuery.trim() === '') {
    setFilteredCompanies([]);
    setShowCompanyList(false);
    return;
  }

  try {
    console.log('Searching for companies with query:', searchQuery);
    console.log('Current user:', currentUser);
    
    const response = await axios.get(
      `${CONFIG.API_BASE_URL}/excel/search`,
      {
        headers: getAuthHeaders(),
        params: {
          company_name: searchQuery,
          page: 1,
          page_size: 20
        }
      }
    );
    
    console.log('Company search response:', response.data);
    console.log('Number of companies found:', response.data.files?.length || 0);
    
    if (response.data.files && response.data.files.length > 0) {
      // Transform the response
      const companies = response.data.files.map(file => ({
        id: file.company_id || file.id,
        name: file.company_name,
        ticker: file.ticker || file.company_name.substring(0, 3).toUpperCase(),
        sector: file.sector || "Financial Services",
        isBackendCompany: true,
        hasIncomeStatement: file.hasIncomeStatement || false,
        hasBalanceSheet: file.hasBalanceSheet || false,
        hasCashFlow: file.hasCashFlow || false,
        companyId: file.company_id,
        latestYear: file.latest_year,
        downloadUrls: file.download_urls
      }));
      
      console.log('Transformed companies:', companies);
      setFilteredCompanies(companies);
      setShowCompanyList(true);
    } else {
      console.log('No companies found in search');
      setFilteredCompanies([]);
      setShowCompanyList(true);
    }
  } catch (error) {
    console.error('Error searching companies:', error);
    console.error('Error response:', error.response?.data);
    setFilteredCompanies([]);
    setShowCompanyList(false);
  }
};

    // Debounce search
    const timer = setTimeout(() => {
      searchCompanies();
    }, 300);

    return () => clearTimeout(timer);
  }, [searchQuery]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowCompanyList(false);
      }
      if (notificationsRef.current && !notificationsRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setShowProfileDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Clear search when not in appropriate section
  useEffect(() => {
    if (userRole === 'admin' && currentSection !== 'data' && searchQuery.trim()) {
      setSearchQuery('');
      setFilteredCompanies([]);
      setShowCompanyList(false);
    }
  }, [currentSection, searchQuery, setSearchQuery, userRole]);

  const confirmLogout = () => {
    setShowLogoutModal(true);
    setShowProfileDropdown(false);
  };

  const handleConfirmLogout = () => {
    setShowLogoutModal(false);
    handleLogout();
  };

  const handleCancelLogout = () => {
    setShowLogoutModal(false);
  };

  const handleCompanySelect = (company) => {
    if (onCompanySelect) {
      onCompanySelect(company);
    }
    // Update search query only if company exists
    if (company && company.name) {
      setSearchQuery(`${company.name} (${company.ticker})`);
    } else {
      // Clear search if company is null/undefined
      setSearchQuery('');
    }
    setShowCompanyList(false);
    
    // Small delay to ensure smooth transition
    setTimeout(() => {
      setShowCompanyList(false);
    }, 100);
  };

  const handleSearchFocus = () => {
    if (searchQuery.trim() && filteredCompanies.length > 0) {
      setShowCompanyList(true);
    }
  };

  const handleSearchKeyDown = (e) => {
    if (e.key === 'Enter' && searchQuery.trim() && filteredCompanies.length > 0) {
      handleCompanySelect(filteredCompanies[0]);
    }
    // Clear search on Escape key
    if (e.key === 'Escape') {
      setShowCompanyList(false);
    }
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    setShowCompanyList(value.trim().length > 0 && filteredCompanies.length > 0);
  };

  const handleClearSearch = () => {
    setSearchQuery('');
    setFilteredCompanies([]);
    setShowCompanyList(false);
    
    // Clear the selection by passing null, but handle gracefully
    if (onCompanySelect && typeof onCompanySelect === 'function') {
      try {
        onCompanySelect(null);
      } catch (err) {
        // Parent component might not handle null, but that's okay
        // The search is still cleared
        console.warn("Could not clear company selection:", err);
      }
    }
  };

  const handleMarkAllAsRead = () => {
    setNotifications(prev => prev.map(notif => ({ ...notif, read: true })));
  };

  const toggleProfileDropdown = () => {
    setShowProfileDropdown(!showProfileDropdown);
    setShowNotifications(false); // Close notifications if open
  };

  const unreadCount = notifications.filter(n => !n.read).length;

  // Determine if search should be shown
  const showSearchBar = () => {
    if (userRole === 'superadmin') return false;
    if (userRole === 'user') return true;
    if (userRole === 'admin') return currentSection === 'data';
    return false;
  };

  // Get user initials for profile circle - FIRST LETTER OF USER'S NAME
  const getUserInitials = () => {
    if (currentUser && currentUser.name) {
      // Return first letter of the name
      return currentUser.name.charAt(0).toUpperCase();
    }
    
    // Fallback: get from email if name not available
    if (currentUser && currentUser.email) {
      return currentUser.email.charAt(0).toUpperCase();
    }
    
    return 'U'; // Default
  };

  // Get user name
  const getUserName = () => {
    if (currentUser && currentUser.name) {
      return currentUser.name;
    }
    
    // Fallback: extract from email
    if (currentUser && currentUser.email) {
      const username = currentUser.email.split('@')[0];
      return username.charAt(0).toUpperCase() + username.slice(1);
    }
    
    return 'User';
  };

  // Get user role for display
  const getUserRoleDisplay = () => {
    if (currentUser && currentUser.role) {
      const role = currentUser.role;
      
      switch(role) {
        case 'superadmin': return 'Super Admin';
        case 'admin': return 'Administrator';
        case 'user': return 'Regular User';
        default: return 'User';
      }
    }
    
    return 'User';
  };

  // Get user email for display
  const getUserEmail = () => {
    if (currentUser && currentUser.email) {
      return currentUser.email;
    }
    return 'No email';
  };

  // EXCEL UPLOAD HANDLER
  const handleUploadClick = () => {
    // Trigger the hidden file input
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleExcelFileSelect = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        
        // Get the first sheet
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        
        // Convert to JSON array (array of arrays for headers)
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        
        // Transform the data to match the expected format
        const formattedData = [];
        
        // Check if we have data
        if (jsonData.length < 2) {
          alert('Excel file must have at least one header row and one data row');
          event.target.value = '';
          return;
        }
        
        // Get headers (first row)
        const headers = jsonData[0];
        
        // Process data rows (skip header row)
        for (let i = 1; i < jsonData.length; i++) {
          const row = jsonData[i];
          if (row && row.length > 0) {
            const dataRow = {};
            
            // Map each column based on headers
            headers.forEach((header, index) => {
              if (header && header.toString().trim() !== '') {
                const headerKey = header.toString().toLowerCase().replace(/\s+/g, '_');
                dataRow[headerKey] = row[index] || '';
              }
            });
            
            // If no particular column found, try common names
            if (!dataRow.particular && headers.some(h => 
              h && h.toString().toLowerCase().includes('particular') || 
              h && h.toString().toLowerCase().includes('item') ||
              h && h.toString().toLowerCase().includes('description')
            )) {
              // Find the particular column
              const particularIndex = headers.findIndex(h => 
                h && (h.toString().toLowerCase().includes('particular') || 
                      h.toString().toLowerCase().includes('item') ||
                      h.toString().toLowerCase().includes('description'))
              );
              if (particularIndex !== -1) {
                dataRow.particular = row[particularIndex] || '';
              }
            }
            
            formattedData.push(dataRow);
          }
        }
        
        // Send the data to parent component
        if (onExcelUpload && typeof onExcelUpload === 'function') {
          onExcelUpload(formattedData, activeStatement);
        } else {
          console.log('Excel data processed:', formattedData);
          alert('Excel data uploaded successfully!');
        }
        
        // Reset file input
        event.target.value = '';
        
      } catch (error) {
        console.error('Error reading Excel file:', error);
        alert('Error reading Excel file. Please ensure it is a valid Excel file with proper structure.');
        event.target.value = '';
      }
    };
    
    reader.onerror = (error) => {
      console.error('FileReader error:', error);
      alert('Error reading file. Please try again.');
      event.target.value = '';
    };
    
    reader.readAsArrayBuffer(file);
  };

  // MAIN DOWNLOAD FUNCTION - Integrated with backend
  const handleDownloadClick = async () => {
    if (!currentCompany || !activeStatement) {
      alert('Please select a company and statement first');
      return;
    }

    setIsDownloading(true);
    
    try {
      console.log('Starting download for:', {
        company: currentCompany.name,
        statement: activeStatement,
        user: currentUser.email
      });

      // Get auth headers
      const headers = getAuthHeaders();
      
      // Step 1: Search for company to get statement ID
      console.log('Searching for company:', currentCompany.name);
      const searchResponse = await axios.get(
        `${CONFIG.API_BASE_URL}/excel/search`,
        {
          headers: headers,
          params: {
            company_name: currentCompany.name,
            page: 1,
            page_size: 10
          }
        }
      );
      
      if (!searchResponse.data.files || searchResponse.data.files.length === 0) {
        alert('Company data not found in the database');
        return;
      }

      const companyData = searchResponse.data.files[0];
      
      // Map frontend statement type to backend type
      const statementTypeMap = {
        "Income Statement": "income_statement",
        "Balance Sheet": "balance_sheet", 
        "Cash Flow": "cash_flow"
      };
      
      const backendType = statementTypeMap[activeStatement];
      const statementInfo = companyData.statement_data?.[backendType];
      
      if (!statementInfo || !statementInfo.statement_id) {
        alert(`No ${activeStatement} data available for download`);
        return;
      }

      console.log('Statement info found:', statementInfo);
      
      // Step 2: Download the Excel file
      console.log('Downloading statement:', statementInfo.statement_id);
      const response = await axios.get(
        `${CONFIG.API_BASE_URL}/excel/statement/${statementInfo.statement_id}/download`,
        {
          headers: headers,
          responseType: 'blob'
        }
      );
      
      // Step 3: Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      
      // Generate filename
      const safeCompanyName = currentCompany.name.replace(/[^a-zA-Z0-9]/g, '_');
      const safeStatement = activeStatement.replace(/\s+/g, '_');
      const filename = `${safeCompanyName}_${safeStatement}.xlsx`;
      
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      
      // Clean up
      window.URL.revokeObjectURL(url);
      
      console.log('✅ Excel file downloaded successfully:', filename);
      
      // Show success message
      setTimeout(() => {
        alert(`✅ Downloaded: ${filename}`);
      }, 500);
      
    } catch (error) {
      console.error('❌ Download error:', error);
      
      // Detailed error handling
      let errorMessage = 'Failed to download Excel file.';
      
      if (error.response) {
        console.error('Response status:', error.response.status);
        console.error('Response data:', error.response.data);
        
        if (error.response.status === 404) {
          errorMessage = 'Excel file not found on the server.';
        } else if (error.response.status === 403) {
          errorMessage = 'You do not have permission to download this file.';
        } else if (error.response.status === 401) {
          errorMessage = 'Authentication failed. Please log in again.';
        } else {
          errorMessage = `Server error (${error.response.status}): ${error.response.data.detail || 'Unknown error'}`;
        }
      } else if (error.request) {
        errorMessage = 'Network error. Please check your connection.';
      } else {
        errorMessage = `Error: ${error.message}`;
      }
      
      alert(`❌ ${errorMessage}`);
      
      // Fallback: Try alternative download method
      try {
        console.log('Trying alternative download method...');
        if (currentCompany.isBackendCompany) {
          const searchResponse = await axios.get(
            `${CONFIG.API_BASE_URL}/excel/search`,
            {
              headers: getAuthHeaders(),
              params: {
                company_name: currentCompany.name,
                page: 1,
                page_size: 10
              }
            }
          );
          
          if (searchResponse.data.files && searchResponse.data.files.length > 0) {
            const companyData = searchResponse.data.files[0];
            const statementTypeMap = {
              "Income Statement": "income_statement",
              "Balance Sheet": "balance_sheet", 
              "Cash Flow": "cash_flow"
            };
            
            const backendType = statementTypeMap[activeStatement];
            const statementInfo = companyData.statement_data?.[backendType];
            
            if (statementInfo && statementInfo.statement_id && statementInfo.job_id) {
              const downloadUrl = `${CONFIG.API_BASE_URL}/upload/jobs/${statementInfo.job_id}/download/${statementInfo.statement_id}`;
              window.open(downloadUrl, '_blank');
              console.log('Opened download in new tab via fallback');
            }
          }
        }
      } catch (fallbackError) {
        console.error('Fallback also failed:', fallbackError);
      }
    } finally {
      setIsDownloading(false);
    }
  };

  // Handle user view download (calls the UserDataView's download function)
  const handleUserDownload = () => {
    // Check if the download function is exposed by UserDataView
    if (typeof window.handleUserDataDownload === 'function') {
      window.handleUserDataDownload();
    } else {
      // Show appropriate message based on context
      if (userRole === 'user') {
        alert('Please select a company and financial statement to download data.');
      } else {
        alert('Download functionality to be implemented');
      }
    }
  };

  // Handle save (placeholder)
  const handleSave = () => {
    console.log('Save clicked');
    alert('Save functionality to be implemented');
  };

  // Determine if download should be enabled
  const shouldEnableDownload = () => {
    if (userRole === 'user') {
      // User view: check if company is selected
      return currentCompany !== null;
    } else if (userRole === 'admin') {
      // Admin view: check if we're in data section with a company
      return currentSection === 'data' && currentCompany !== null;
    }
    return false;
  };

  return (
    <>
      {/* Hidden file input for Excel upload */}
      <input
        type="file"
        ref={fileInputRef}
        accept=".xlsx,.xls,.csv"
        onChange={handleExcelFileSelect}
        style={{ display: 'none' }}
      />

      <nav className="bg-white dark:bg-gray-800 shadow-sm border-b border-gray-200 dark:border-gray-700">
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            {/* Left side */}
            <div className="flex items-center flex-shrink-0 gap-4">
              {/* Mobile menu button */}
              {(userRole === 'admin' || userRole === 'superadmin') && (
                <button
                  onClick={() => setSidebarOpen(!sidebarOpen)}
                  className="p-2 rounded-lg text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 lg:hidden mr-2"
                >
                  <FaBars />
                </button>
              )}
              
              {/* Logo - Clickable for all users to go home */}
              <div 
                className="flex items-center mr-2 cursor-pointer hover:opacity-80 transition-opacity" 
                onClick={() => onHomeClick && onHomeClick()}
                title="Go to Home"
              >
                <img src={logo} alt="NIRAFINHUB Logo" className="h-9 w-auto" />
                <div className="ml-2">
                  <span className="text-lg font-bold text-gray-900 dark:text-white hidden sm:inline">
                    NIRA FINHUB
                  </span>
                  {userRole === 'superadmin' && (
                    <div className="flex items-center gap-1">
                      <FaCrown className="text-yellow-500 text-xs" />
                      <span className="text-xs font-semibold text-purple-600 dark:text-purple-400">
                        SuperAdmin
                      </span>
                    </div>
                  )}
                </div>
              </div>

              {/* Search Bar */}
              {showSearchBar() && (
                <div className="relative w-72 lg:w-80 ml-2" ref={searchRef}>
                  <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
                  <input
                    value={searchQuery}
                    onChange={handleSearchChange}
                    onFocus={handleSearchFocus}
                    onKeyDown={handleSearchKeyDown}
                    placeholder="Search company or ticker..."
                    className="w-full pl-9 pr-10 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg
                             focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                             bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                  />

                  {/* Clear search button */}
                  {searchQuery && (
                    <button
                      onClick={handleClearSearch}
                      className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
                      title="Clear search"
                    >
                      <FaTimes className="text-sm" />
                    </button>
                  )}

                  {/* Company dropdown - SHOWS BACKEND COMPANIES */}
                  {showCompanyList && searchQuery && filteredCompanies.length > 0 && (
                    <div className="absolute z-50 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg
                                  w-full max-h-60 overflow-y-auto shadow-lg mt-1">
                      <div className="px-3 py-2 border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-700">
                        <p className="text-xs font-medium text-gray-500 dark:text-gray-400">
                          {filteredCompanies.length} company{filteredCompanies.length !== 1 ? 's' : ''} found
                        </p>
                      </div>
                      {filteredCompanies.map(c => (
                        <div
                          key={c.id}
                          onClick={() => handleCompanySelect(c)}
                          className="px-3 py-2 hover:bg-gray-100 dark:hover:bg-gray-700
                                   cursor-pointer text-sm border-b border-gray-200 dark:border-gray-600 last:border-b-0"
                        >
                          <div className="font-medium text-gray-900 dark:text-white">{c.name}</div>
                          <div className="text-xs text-gray-500 dark:text-gray-400">
                            {c.ticker} • {c.sector}
                            {c.hasIncomeStatement && <span className="ml-2 text-green-600">Income ✓</span>}
                            {c.hasBalanceSheet && <span className="ml-2 text-blue-600">Balance ✓</span>}
                            {c.hasCashFlow && <span className="ml-2 text-purple-600">Cash ✓</span>}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                 
                </div>
              )}
            </div>
            
            {/* Right side */}
            <div className="flex items-center gap-3">
             

             

              {/* User Profile - ONLY SHOW INITIAL "R" */}
              <div className="relative" ref={profileRef}>
                <button
                  onClick={toggleProfileDropdown}
                  className="p-1.5 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                  title="User Profile"
                >
                  {/* User Profile Circle with ONLY THE INITIAL - ROUNDED CORNER */}
                  <div className="w-10 h-10 rounded-full bg-gradient-to-r from-blue-600 to-purple-600 flex items-center justify-center text-white font-semibold text-lg shadow-md hover:shadow-lg transition-shadow">
                    {getUserInitials()}
                  </div>
                </button>
                
                {/* Profile Dropdown - SHOWS FULL DETAILS WHEN CLICKED */}
                {showProfileDropdown && (
                  <div className="absolute right-0 mt-2 w-64 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-xl shadow-2xl z-50">
                    {/* Profile Header */}
                    <div className="p-5 border-b border-gray-200 dark:border-gray-700 bg-gradient-to-r from-blue-50 to-purple-50 dark:from-gray-700 dark:to-gray-800">
                      <div className="flex items-center space-x-4">
                        <div className="w-14 h-14 rounded-full bg-gradient-to-r from-blue-600 to-purple-600 flex items-center justify-center text-white font-semibold text-2xl shadow-lg">
                          {getUserInitials()}
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="font-bold text-gray-900 dark:text-white text-lg truncate">
                            {getUserName()}
                          </p>
                          <p className="text-sm text-gray-600 dark:text-gray-300 truncate">
                            {getUserEmail()}
                          </p>
                          <p className="mt-2">
                            <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-gradient-to-r from-blue-100 to-purple-100 text-blue-800 dark:from-blue-900/30 dark:to-purple-900/30 dark:text-blue-300">
                              {getUserRoleDisplay()}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                    
                    {/* Logout Button */}
                    <div className="p-3">
                      <button
                        onClick={confirmLogout}
                        className="flex items-center justify-center w-full px-4 py-3 text-white bg-gradient-to-r from-red-500 to-pink-600 hover:from-red-600 hover:to-pink-700 rounded-lg transition-all shadow-md hover:shadow-lg font-medium"
                      >
                        <FaSignOutAlt className="mr-2" />
                        Logout
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Logout Confirmation Modal */}
      {showLogoutModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl w-full max-w-md">
            <div className="flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700">
              <div className="flex items-center space-x-3">
                <div className="p-2 bg-red-100 dark:bg-red-900/20 rounded-lg">
                  <FaExclamationTriangle className="text-red-600 dark:text-red-400 text-lg" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                    Confirm Logout
                  </h3>
                  <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                    Are you sure you want to logout, {getUserName()}?
                  </p>
                </div>
              </div>
              <button
                onClick={handleCancelLogout}
                className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
              >
                <FaTimes className="text-lg" />
              </button>
            </div>

            <div className="flex justify-end space-x-3 p-6 border-t border-gray-200 dark:border-gray-700">
              <button
                onClick={handleCancelLogout}
                className="px-5 py-2.5 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors focus:ring-2 focus:ring-gray-300 dark:focus:ring-gray-600"
              >
                Cancel
              </button>
              <button
                onClick={handleConfirmLogout}
                className="px-5 py-2.5 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 transition-colors focus:ring-2 focus:ring-red-300 flex items-center space-x-2"
              >
                <FaSignOutAlt />
                <span>Yes, Logout</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TopNavbar;
